import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-intro-create-client-shows',
  templateUrl: './intro-create-client-shows.component.html',
  styleUrls: ['./intro-create-client-shows.component.css']
})
export class IntroCreateClientShowsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
